export function initTrTd(type, list, num, cn) {
  const arr = [];
  for (let i = 0; i < list.length / num; i++) {
    const tr = {
      h: "tr",
      c: "",
      z: [],
    };
    for (let j = 0; j < num; j++) {
      const item = list[i * num + j];
      tr.z.push({
        h: "td",
        c: "",
        z: [
          {
            h: "span",
            c: item.className,
            html: item.html || item[type],
            event: (ev) => {
              cn(item, ev);
            },
          },
        ],
      });
    }
    arr.push(tr);
  }
  return arr;
}
